<template>
  <div class="product-detail">
    <div class="container-bar">
      <div class="left-col">
        <router-link :to="get_shop_link[0].full_url">
          <div class="back-btn">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20.62"
            height="15.07"
            viewBox="0 0 20.62 15.07"
          >
            <g
              id="Group_104"
              data-name="Group 104"
              transform="translate(0.534 0.535)"
            >
              <g id="menu" transform="translate(0 0)">
                <g
                  id="Group_103"
                  data-name="Group 103"
                  transform="translate(0 0)"
                >
                  <path
                    id="Union_6"
                    data-name="Union 6"
                    d="M9.062.879a37.229,37.229,0,0,0,4.729,3.3c.457.271.925.53,1.407.755-.7.029-1.409,0-2.113-.029-.748-.031-1.487-.06-2.194-.025-3.048.165-6.065.724-9.125.666-1.052-.017-2.779,1.559-1,1.592,3.468.064,6.869-.624,10.328-.7.573-.011,1.159,0,1.752.016a19,19,0,0,0,3.911-.186,56.985,56.985,0,0,0-5.136,5.369c-.442.6-.091,1.6.513.767,1.772-2.432,4.258-4.2,6.158-6.521a1,1,0,0,0,.158-.271.794.794,0,0,0,.25-.608c0-.027,0-.052,0-.075-.015-.457-.669-.551-1.321-.4A9.019,9.019,0,0,1,13.969,2.97a41.86,41.86,0,0,1-3.9-2.78A.9.9,0,0,0,9.5,0C8.967,0,8.481.4,9.062.879Z"
                    transform="matrix(-0.998, -0.07, 0.07, -0.998, 18.659, 14.001)"
                    fill="#101820"
                    stroke="#101820"
                    stroke-width="1"
                  />
                </g>
              </g>
            </g>
          </svg>

          <span class="f-21 bold-italic">{{$fn.tr('უკან')}}</span>
        </div>
        </router-link>
        <picture v-for="(pic, index) in getImages" :key="index">
          <source media="(max-width:767px)" :srcset="_.get(pic, 'devices.mobile')">
          <source media="(max-width:1023px)" :srcset="_.get(pic, 'devices.tablet')">
          <img :src="_.get(pic, 'devices.desktop')" :alt="_.get(pic, 'title')" :class="{active: index === 0}">
        </picture>
           <div class="arrows-wrapper" v-if="_.get(getImages, 'length') > 1">
                 <div class="prev-btn pointer" @click="prevPic($event)">
         <svg xmlns="http://www.w3.org/2000/svg" width="35.581" height="27.07" viewBox="0 0 35.581 27.07">
  <g id="Group_3395" data-name="Group 3395" transform="translate(734.307 630.535) rotate(-180)">
    <g id="Group_3386" data-name="Group 3386" transform="translate(725.019 602.26)" opacity="0.3">
      <g id="menu" transform="translate(-24.753 3.741)">
        <g id="Group_103" data-name="Group 103" transform="translate(0 0)">
          <path id="Union_6" data-name="Union 6" d="M15.535,20.31a63.817,63.817,0,0,1,8.107-5.662c.783-.464,1.585-.908,2.411-1.294-1.195-.049-2.414,0-3.622.049-1.282.053-2.55.1-3.76.043C13.446,13.164,8.274,12.2,3.029,12.3c-1.8.03-4.764-2.672-1.708-2.729,5.945-.11,11.775,1.069,17.7,1.2.983.018,1.987,0,3-.028a32.561,32.561,0,0,1,6.7.319c-2.928-3.078-6.282-5.747-8.8-9.2-.758-1.035-.156-2.737.879-1.314,3.037,4.168,7.3,7.2,10.557,11.178a1.71,1.71,0,0,1,.271.464,1.362,1.362,0,0,1,.429,1.041c0,.046,0,.089,0,.129-.026.784-1.146.945-2.265.685a15.461,15.461,0,0,0-5.849,2.683,71.757,71.757,0,0,0-6.679,4.765,1.536,1.536,0,0,1-.98.326C15.372,21.817,14.539,21.131,15.535,20.31Z" transform="matrix(0.998, -0.07, 0.07, 0.998, 0, 2.237)" fill="#101820" stroke="#101820" stroke-width="1"/>
        </g>
      </g>
    </g>
    <g id="Group_1490" data-name="Group 1490" transform="translate(724.019 600.26)">
      <g id="menu-2" data-name="menu" transform="translate(-24.753 3.741)">
        <g id="Group_103-2" data-name="Group 103" transform="translate(0 0)">
          <path id="Union_6-2" data-name="Union 6" d="M15.535,20.31a63.817,63.817,0,0,1,8.107-5.662c.783-.464,1.585-.908,2.411-1.294-1.195-.049-2.414,0-3.622.049-1.282.053-2.55.1-3.76.043C13.446,13.164,8.274,12.2,3.029,12.3c-1.8.03-4.764-2.672-1.708-2.729,5.945-.11,11.775,1.069,17.7,1.2.983.018,1.987,0,3-.028a32.561,32.561,0,0,1,6.7.319c-2.928-3.078-6.282-5.747-8.8-9.2-.758-1.035-.156-2.737.879-1.314,3.037,4.168,7.3,7.2,10.557,11.178a1.71,1.71,0,0,1,.271.464,1.362,1.362,0,0,1,.429,1.041c0,.046,0,.089,0,.129-.026.784-1.146.945-2.265.685a15.461,15.461,0,0,0-5.849,2.683,71.757,71.757,0,0,0-6.679,4.765,1.536,1.536,0,0,1-.98.326C15.372,21.817,14.539,21.131,15.535,20.31Z" transform="matrix(0.998, -0.07, 0.07, 0.998, 0, 2.237)" fill="#fff" stroke="#fff" stroke-width="1"/>
        </g>
      </g>
    </g>
  </g>
</svg>

        </div>
        <div class="next-btn pointer" @click="nextPic($event)">
          <svg xmlns="http://www.w3.org/2000/svg" width="35.581" height="27.07" viewBox="0 0 35.581 27.07">
  <g id="Group_3387" data-name="Group 3387" transform="translate(-698.726 -603.465)">
    <g id="Group_3386" data-name="Group 3386" transform="translate(725.019 602.26)" opacity="0.3">
      <g id="menu" transform="translate(-24.753 3.741)">
        <g id="Group_103" data-name="Group 103" transform="translate(0 0)">
          <path id="Union_6" data-name="Union 6" d="M15.535,20.31a63.817,63.817,0,0,1,8.107-5.662c.783-.464,1.585-.908,2.411-1.294-1.195-.049-2.414,0-3.622.049-1.282.053-2.55.1-3.76.043C13.446,13.164,8.274,12.2,3.029,12.3c-1.8.03-4.764-2.672-1.708-2.729,5.945-.11,11.775,1.069,17.7,1.2.983.018,1.987,0,3-.028a32.561,32.561,0,0,1,6.7.319c-2.928-3.078-6.282-5.747-8.8-9.2-.758-1.035-.156-2.737.879-1.314,3.037,4.168,7.3,7.2,10.557,11.178a1.71,1.71,0,0,1,.271.464,1.362,1.362,0,0,1,.429,1.041c0,.046,0,.089,0,.129-.026.784-1.146.945-2.265.685a15.461,15.461,0,0,0-5.849,2.683,71.757,71.757,0,0,0-6.679,4.765,1.536,1.536,0,0,1-.98.326C15.372,21.817,14.539,21.131,15.535,20.31Z" transform="matrix(0.998, -0.07, 0.07, 0.998, 0, 2.237)" fill="#101820" stroke="#101820" stroke-width="1"/>
        </g>
      </g>
    </g>
    <g id="Group_1490" data-name="Group 1490" transform="translate(724.019 600.26)">
      <g id="menu-2" data-name="menu" transform="translate(-24.753 3.741)">
        <g id="Group_103-2" data-name="Group 103" transform="translate(0 0)">
          <path id="Union_6-2" data-name="Union 6" d="M15.535,20.31a63.817,63.817,0,0,1,8.107-5.662c.783-.464,1.585-.908,2.411-1.294-1.195-.049-2.414,0-3.622.049-1.282.053-2.55.1-3.76.043C13.446,13.164,8.274,12.2,3.029,12.3c-1.8.03-4.764-2.672-1.708-2.729,5.945-.11,11.775,1.069,17.7,1.2.983.018,1.987,0,3-.028a32.561,32.561,0,0,1,6.7.319c-2.928-3.078-6.282-5.747-8.8-9.2-.758-1.035-.156-2.737.879-1.314,3.037,4.168,7.3,7.2,10.557,11.178a1.71,1.71,0,0,1,.271.464,1.362,1.362,0,0,1,.429,1.041c0,.046,0,.089,0,.129-.026.784-1.146.945-2.265.685a15.461,15.461,0,0,0-5.849,2.683,71.757,71.757,0,0,0-6.679,4.765,1.536,1.536,0,0,1-.98.326C15.372,21.817,14.539,21.131,15.535,20.31Z" transform="matrix(0.998, -0.07, 0.07, 0.998, 0, 2.237)" fill="#fff" stroke="#fff" stroke-width="1"/>
        </g>
      </g>
    </g>
  </g>
</svg>

        </div>
              </div> 
          <div class="lines-wrapper" v-if="_.get(getImages, 'length') > 1">
              <div class="line-w" v-for="(pic, index) in getImages" :key="index" :class="{active: index === 0}" @click="changeActivePic(index)"></div>
          </div>
      </div>

      <div class="right-col">
        <div class="back-btn" @click="backShop">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20.62"
            height="15.07"
            viewBox="0 0 20.62 15.07"
          >
            <g
              id="Group_104"
              data-name="Group 104"
              transform="translate(0.534 0.535)"
            >
              <g id="menu" transform="translate(0 0)">
                <g
                  id="Group_103"
                  data-name="Group 103"
                  transform="translate(0 0)"
                >
                  <path
                    id="Union_6"
                    data-name="Union 6"
                    d="M9.062.879a37.229,37.229,0,0,0,4.729,3.3c.457.271.925.53,1.407.755-.7.029-1.409,0-2.113-.029-.748-.031-1.487-.06-2.194-.025-3.048.165-6.065.724-9.125.666-1.052-.017-2.779,1.559-1,1.592,3.468.064,6.869-.624,10.328-.7.573-.011,1.159,0,1.752.016a19,19,0,0,0,3.911-.186,56.985,56.985,0,0,0-5.136,5.369c-.442.6-.091,1.6.513.767,1.772-2.432,4.258-4.2,6.158-6.521a1,1,0,0,0,.158-.271.794.794,0,0,0,.25-.608c0-.027,0-.052,0-.075-.015-.457-.669-.551-1.321-.4A9.019,9.019,0,0,1,13.969,2.97a41.86,41.86,0,0,1-3.9-2.78A.9.9,0,0,0,9.5,0C8.967,0,8.481.4,9.062.879Z"
                    transform="matrix(-0.998, -0.07, 0.07, -0.998, 18.659, 14.001)"
                    fill="#101820"
                    stroke="#101820"
                    stroke-width="1"
                  />
                </g>
              </g>
            </g>
          </svg>

          <span class="f-21 bold-italic">{{ $fn.tr('უკან') }}</span>
        </div>

        <h2 class="f-55 bold-italic product-ttl">{{getTitle}}</h2>
        <div class="editor" v-if="this.contentData.data.list[0].description.ge !== null || this.contentData.data.list[0].description.en !== null" v-html="getDesc"></div>
        <span class="bold-italic f-34 old-price" v-if="contentData.data.list[0].oldprice !== 0">{{get_old_price}} ₾</span>
        <span class="bold-italic f-34 product-price">{{getPrice}} ₾</span>
        <div class="sizes" v-if="sizeAcrive">
            <span class="f-16 light-italic ttl">{{ $fn.tr('ზომები') }}:</span>
            <div class="inner">
                 <div class="size" v-for="(size, index) in getSizes" :key="index" :class="{active: index === 0}" @click="changeActive($event, _.get(size, 'title_en'));">
                <span class="bold-italic f-21">{{_.get(size, 'title_en')}}</span>
            </div>
            </div>
           
        </div>

        <div class="amount">
             <span class="f-16 light-italic ttl">{{ $fn.tr('რაოდენობა') }}:</span>
                <div class="inner">
                <el-input-number v-model="num" :min="1" :max="1000"></el-input-number>      
            </div>   
        </div>

        <div :class="{ 'hideClassOpacity' : disableButton }" class="add-to-cart" @click="addToCart">
            <svg xmlns="http://www.w3.org/2000/svg" width="27.696" height="32" viewBox="0 0 27.696 32">
  <path id="shopping-bag" d="M27.691,30.949,25.258,7.788a.953.953,0,0,0-.947-.853H19.74V5.892a5.892,5.892,0,0,0-11.784,0V6.935H3.384a.953.953,0,0,0-.947.853L0,30.949A.952.952,0,0,0,.952,32H26.743a.953.953,0,0,0,.948-1.052ZM9.86,5.892a3.987,3.987,0,0,1,7.975,0V6.935H9.86ZM2.01,30.1,4.242,8.839H7.955v2.1a.952.952,0,1,0,1.9,0v-2.1h7.975v2.1a.952.952,0,0,0,1.9,0v-2.1h3.714L25.686,30.1Zm0,0" transform="translate(0 0)" fill="#fff"/>
</svg>

            <span class="f-21">{{ $fn.tr(cardTest) }}</span>
        </div>
        <ShareRow />
      </div>
    </div>

       <portal to="modal">
    <transition name="burger-fade">
      <div class="success-modal" v-if="added">
         <div class="overlay-pic" @click="added = !added"></div>
            <div class="success-box">
              <img src="@/assets/img/ptsichka.png" alt="">
              <span class="f-21 bold-italic success-message">{{ $fn.tr('პროდუქტი წარმატებით დაემატა')  }}</span>
              <div class="go-to-cart" @click="getCartLing">
                <span class="f-21">{{ $fn.tr('კალათის ნახვა') }}</span>
              </div>

              <div class="go-to-product" @click="backProduct">
                <span class="f-21">{{ $fn.tr('პროდუქტში დაბრუნება') }}</span>
              </div>
            </div>

      </div>
     

    </transition>
    </portal>
  </div>
</template>

<script>
import ShareRow from '@/components/smartComponents/ShareRow';
export default {
  props: ["contentData"],
    components: {ShareRow},
       data() {
      return {
        added: false,
        num: 1,
        sizeVal: null,
        size: null,
        link: null,
        obj: {},
        cardObject: [],
        disableButton: false,
        disableButtonGift: false,
        cardTest: "კალათაში დამატება",
        cardTestGift: "დამატება",
        sizeAcrive: true,
      };
    },
    computed: {
        curr_status(){
          return this.$store.state.main.current_content_request_status;
        },
              get_shop_link(){
          return this.$store.state.main.indx.menus.filter(p => p.url_slug === 'shop');
        },
        getDesc() {
          return _.get(this.contentData, 'data.list.0.description')
        },
        product(){
           return this.$store.state.main.shopList;
        },
        getTitle() {
          return _.get(this.contentData, 'data.list.0.title')
        },
        getPrice() {
          var num = _.get(this.contentData, 'data.list.0.price') * this.num 
          return parseFloat(num).toFixed(2)
        },
        get_old_price(){
          let n = _.get(this.contentData, 'data.list.0.oldprice'); 
          return parseFloat(n).toFixed(2);
        },
        getImages() {
          return _.get(this.contentData, 'data.list.0.images')
        },
        getId() {
          return _.get(this.contentData, 'data.list.0.id')
        },
        getGiftId() {
          return _.get(this.contentData, 'data.list.0.gift_item.0.id')
        },
        getSizes() {
          var arr = _.get(this.contentData, 'data.list.0.allAttributes')
          var secRes = _.get(this.$store.state.main.indx, 'attributes.size')
          var finalArr = []
          var epicArr = []
          if (arr !== undefined) {
          arr.forEach(function(item) {
            finalArr.push(secRes.filter(el => el.id === item))
          })
          // console.log('final', finalArr)
          finalArr.forEach(function(item) {
            item.forEach(function(x) {
              epicArr.push(x)
            })
          })
          return epicArr
        }
        }
    },
    mounted() {
      // console.log(this.$route)
        setTimeout(() => {
          this.link = this.$route.fullPath
          this.size = _.get(this.getSizes, '0.title_en')
          this.checkAddToCard()
          if (this.getSizes.length === 0) {
            this.sizeAcrive = false
          }
        }, 500);
    },
    methods: {
      backShop() {
        this.$store.state.main.locale == 'ge' ? this.$router.push('/ge/shop')
        : this.$router.push('/en/shop');
      },
       getCartLing() {
            if (this.$store.state.main.locale == 'ge') {
              return this.$router.push('/ge/cart')
            } else {
              return this.$router.push('/en/cart');
            }
        },
      backProduct() {
        this.added = !this.added
        document.location.reload(true)
      },
      back() {
        this.$router.go(-1)
      },
      checkAddToCard() {
        var arr = JSON.parse(localStorage.getItem('Product'))
        for (var i = 0; i < _.get(arr, 'length'); i++) {
          if (arr[i].ProductObject.id === this.getId) {
            this.cardTest = "უკვე დამატებულია"
            this.disableButton = true
          } else if (arr[i].ProductObject.id === this.getGiftId) {
            this.cardTestGift = "დამატებულია"
            this.disableButtonGift = true
          }
        }
      },
      addToCart(){
        this.cardObject = JSON.parse(localStorage.getItem('Product')) || [];
         this.obj = {
           ProductObject: _.get(this.contentData, 'data.list.0'),
           mount: this.num,
           size: this.size,
           price: this.getPrice,
           link: this.link,
           staticPrice: _.get(this.contentData, 'data.list.0.price')
          }
        this.cardObject.push(this.obj)
        localStorage.setItem('Product', JSON.stringify(this.cardObject))
        this.added = !this.added;
        this.cardTest = "უკვე დამატებულია"
        this.disableButton = true
      },
      addToCartGift() {
       this.cardObject = JSON.parse(localStorage.getItem('Product')) || [];
         this.obj = {
           ProductObject: _.get(this.contentData, 'data.list.0.gift_item.0'),
           mount: 1,
           price: _.get(this.contentData, 'data.list.0.gift_item.0.price')
          }
        this.cardObject.push(this.obj)
        localStorage.setItem('Product', JSON.stringify(this.cardObject))
        this.added = !this.added;
        this.cardTestGift = "დამატებულია"
        this.disableButtonGift = true
      },
        changeActive(e, symbol){
            this.size = symbol
            let target = e.currentTarget;
            let active = target.parentElement.querySelector(".active");
            if(target.classList.contains("active")){
                return;
            } else {
                active.classList.remove("active");    
                target.classList.add("active");
            }
        },

          changeActivePic(e){
            
          //  console.log(e)
           let imgs = document.querySelectorAll(".left-col img");
           let lines = document.querySelectorAll(".left-col .line-w");
           imgs.forEach(im => {
               im.classList.remove("active");
           })
            lines.forEach(l => {
               l.classList.remove("active");
           })
           lines[e].classList.add("active");
           imgs[e].classList.add("active");

        },

        	nextPic(e, imgArr) {
    
     

    let img = e.currentTarget.parentElement.parentElement.querySelectorAll("img");
    let imgDup = [...e.currentTarget.parentElement.parentElement.querySelectorAll("img")];
     let active = e.currentTarget.parentElement.parentElement.querySelector(".active");
       
     let activeIndex = imgDup.indexOf(active);
    
    //  console.log(e.currentTarget.parentElement.parentElement)
    
    let lines = e.currentTarget.parentElement.parentElement.querySelectorAll(".lines-wrapper .line-w");
    let linesDup = [...e.currentTarget.parentElement.parentElement.querySelectorAll(".lines-wrapper .line-w")];
    let activeLine = e.currentTarget.parentElement.parentElement.querySelector(".lines-wrapper .active");
    let activeLineIndex = linesDup.indexOf(activeLine);
   
   if(activeIndex == img.length -1){
       activeLine.classList.remove("active"); 
      active.classList.remove("active");
      lines[0].classList.add("active");
      img[0].classList.add("active");

 
    activeLineIndex = linesDup.indexOf(activeLine);
    activeIndex = imgDup.indexOf(active);
      
      // console.log("bolo")
    } else {
        lines[activeIndex].classList.remove("active");
     img[activeIndex].classList.remove("active");
    
    lines[activeIndex +1].classList.add("active");
    img[activeIndex +1].classList.add("active");
      // console.log("hey")
    }

      // console.log(activeIndex)
  // console.log(img)


  
   
    // console.log(activeIndex)
  
      
    
  
    
     
    },
  	prevPic(e) {
     
    let img = e.currentTarget.parentElement.parentElement.querySelectorAll("img");
    let imgDup = [...e.currentTarget.parentElement.parentElement.querySelectorAll("img")];
     let active = e.currentTarget.parentElement.parentElement.querySelector(".active");
       
     let activeIndex = imgDup.indexOf(active);


      
    let lines = e.currentTarget.parentElement.parentElement.querySelectorAll(".lines-wrapper .line-w");
    let linesDup = [...e.currentTarget.parentElement.parentElement.querySelectorAll(".lines-wrapper .line-w")];
    let activeLine = e.currentTarget.parentElement.parentElement.querySelector(".lines-wrapper .active");
    let activeLineIndex = linesDup.indexOf(activeLine);


    //  console.log(activeIndex)
     
   
   
   if(activeIndex == 0){
        activeLine.classList.remove("active"); 
      active.classList.remove("active");
       lines[lines.length -1].classList.add("active");
      img[img.length -1].classList.add("active");
 
    activeLineIndex = linesDup.indexOf(activeLine);
    activeIndex = imgDup.indexOf(active);
      
      // console.log("bolo")
    } else {
    lines[activeLineIndex].classList.remove("active");
     img[activeIndex].classList.remove("active");
    lines[activeLineIndex -1].classList.add("active");
    img[activeIndex -1].classList.add("active");
      // console.log("hey")
    }

      // console.log(activeIndex)
  // console.log(img)


  
   
    // console.log(activeIndex)
  
  
    },
    },

     watch: {
    '$route'(to, from){
      this.$store.state.main.updateLs3 = !this.$store.state.main.updateLs3;
      // console.log('route changed')
     
      // console.log("hi")
    },
    
    curr_status(ns, os){
      if(ns === 'done'){
        this.$store.state.main.updateLs2 = !this.$store.state.main.updateLs2;
        setTimeout(() => {
          this.newsLoaded = true;
        }, 300);
        
      } 
    }
  },
};
</script>


<style lang="scss">
.hideClassOpacity {
  pointer-events: none;
  opacity: 0.7;
}
.visibleClass {
  visibility: hidden;
}
.editor {
  margin-bottom: 34px;
}
.editor p {
  font-size: 16px;
  color: #101820;
  font-family: "FiraGO-Italic";
}
.success-modal{
     position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: 9999;
    .overlay-pic{
     position: absolute;
     top: 0;
     left: 0;
     height: 100%;
     width: 100%;
     background-color: rgba(16, 24, 32, 0.8);
    }
}
.success-box{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 350px;
  height: 410px;
  background-color: white;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-top: 17px;
   z-index: 99999;
   .success-message{
     color: #044B30;
     width: 216px;
     text-align: center;
     margin-bottom: 52.2px;
   }
   .go-to-cart{
     background: url('../../assets/img/bckcartbg.png');
     background-size: 100% 100%;
     width: fit-content;
     display: flex;
     height: 49px;
     padding-left: 32px;
     padding-right: 32px;
     align-items: center;
     cursor: pointer;
     margin-bottom: 13px;
     span{
       color: white;
     }
   }
  

   .go-to-product{
     background: url('../../assets/img/backtoproducts.png');
     background-size: 100% 100%;
     width: fit-content;
     display: flex;
     height: 49px;
     padding-left: 32px;
     padding-right: 32px;
     align-items: center;
     cursor: pointer;
    
     
   }
   @media (max-width: 413px){
    width: 280px;
     .go-to-product{
       width: 260px;
       span{
         font-size: 16px;
       }
     }
  }
   img{
     width: 139px;
     height: 139px;
   }
}
.product-detail .old-price{
  font-size: 16px;
  text-decoration: line-through;
}
@media (max-width: 1023px){
  .product-dedtail .old-price, .product-price, .editor p{
  text-align: center;
}
}

</style>


<style lang="scss" scoped>

</style>